export const workshop = [
  'Dr. Tech Auto Care Sdn Bhd ( Jalan Putra ) ',
  'Dr. Tech Auto Care Sdn Bhd ( Jalan Kristal) ',
  'German Auto Garage Enterprise',
  'Lean Seng Enterprise Sdn Bhd',
  'Pusat Servis Tayar & Bateri Hooi',
  'Pad Pro Garage',
  'Chung Lik Tyre & Battery Service',
  'Marvel Tyre PLT',
  'Wh Wheel Speed Car World Sdn Bhd',
  'Spgc Enterprise Sdn Bhd',
  'Maxiria Enterprise Sdn Bhd',
  'Heap Hoe Tyres Sdn Bhd',
  'LSF Tyre Sdn Bhd',
  'Jia Seng Automobile Service Centre',
  'Rock Sky Car Care Centre',
  'Hy Two Tyre And Battery Service Centre',
  'Chian Soon Tyres & Auto Sdn Bhd',
  'Steelmax Tyre Sdn Bhd',
  'Kean Seng Tyre & Battery S/B',
  'Tat Kuang Tyre & Car Service (M) Sdn. Bhd.',
  'Hong Seng Auto Tyre'
]
